import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Expand/collapse region, replacing react-bootstrap's `<Collapse in={...}>`.
 *
 * The height is animated with a grid track rather than a pixel value. An
 * element's natural height is not a number you can transition to — `auto` is
 * not interpolable — which is why the Bootstrap version measured the child on
 * every toggle and wrote an inline `height` through a chain of transition
 * classes. A grid whose single row goes from `0fr` to `1fr` interpolates on its
 * own, so the content stays free to be however tall it is and nothing has to be
 * measured.
 *
 * The child needs `min-height: 0` or it refuses to shrink below its content,
 * and `overflow: hidden` so the text is clipped rather than spilling while the
 * track closes.
 */
const Collapse = ({ open, children, className, ...props }) => (
  <div
    className={cn(
      "grid transition-[grid-template-rows] duration-300 ease-in-out motion-reduce:transition-none",
      open ? "grid-rows-[1fr]" : "grid-rows-[0fr]",
      className
    )}
    aria-hidden={!open}
    {...props}
  >
    {/* `overflow: hidden` only clips: a closed panel's links and buttons stay in
        the tab order, so keyboard focus disappears into a region nobody can see.
        Bootstrap avoided this by going to `display: none`. `visibility` does the
        same for focus and, unlike display, takes part in the transition — it
        flips discretely at the end, so the panel stays visible for the whole
        closing animation instead of vanishing on the first frame. */}
    <div
      className={cn(
        "min-h-0 overflow-hidden transition-[visibility] duration-300",
        open ? "visible" : "invisible"
      )}
    >
      {children}
    </div>
  </div>
);

export { Collapse };
